export { default as rHomepage } from './homepage';
export { default as rLandingFooter } from './footer';
export { default as rLandingHeader } from './header';
export { default as rLandingDefaultPage } from './defaultPage';
